import { render, staticRenderFns } from "./ExerciseSets.vue?vue&type=template&id=00ded13e&"
import script from "./ExerciseSets.vue?vue&type=script&lang=js&"
export * from "./ExerciseSets.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseSets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VDataTable})
